module.exports = __webpack_public_path__ + "static/media/save_img.b7b6a06a.jpg";